import { addUserToGroup, deleteGroup, getGroups, saveGroup } from '../Groups.access';
import { Group } from '../Groups.access';
import { bsAlert, AlertTypes } from '@shared/components/BsAlerts';

export const fetchGroups = async (): Promise<Group[]> => {
    try {
        const groups = await getGroups();
        return groups;
    } catch (error) {
        bsAlert({
            type: AlertTypes.Danger,
            title: $Resources.ErrorHeading,
            content: $Resources.AclErrorFetchGroups,
        });
        throw error;
    }
};

export const saveGroupInfo = async (groupData: { name: string; groupId?: string }): Promise<string | null> => {
    try {
        const groupId = await saveGroup(groupData);
        if (!groupId) {
            bsAlert({
                type: AlertTypes.Danger,
                title: $Resources.ErrorHeading,
                content: $Resources.AclErrorSaveGroup,
            });
            return null;
        }

        bsAlert({
            title: $Resources.AlertSuccessHeading,
            content: $Resources.AclSuccessSaveGroup,
        });
        return groupId;
    } catch (error) {
        bsAlert({
            type: AlertTypes.Danger,
            title: $Resources.ErrorHeading,
            content: $Resources.AclErrorUnexpectedSaveGroup,
        });
        return null;
    }
};

export const addUsersToGroup = async (groupId: string, userIds: string[]): Promise<void> => {
    try {
        const results = await Promise.all(
            userIds.map(async (userId) => {
                try {
                    await addUserToGroup(groupId, userId);
                    return { success: true, userId };
                } catch (error) {
                    return { success: false, userId };
                }
            })
        );

        const allSucceeded = results.every((result) => result.success);

        if (allSucceeded) {
            bsAlert({
                title: $Resources.AlertSuccessHeading,
                content: $Resources.AclSuccessAddUsersToGroup,
            });
        } else {
            const failedUsers = results.filter((result) => !result.success).map((result) => result.userId);

            bsAlert({
                type: AlertTypes.Danger,
                title: $Resources.ErrorHeading,
                content: `${$Resources.AclErrorAddUsersToGroup} ${failedUsers.join(', ')}`,
            });
        }
    } catch (error) {
        bsAlert({
            type: AlertTypes.Danger,
            title: $Resources.ErrorHeading,
            content: $Resources.AclErrorUnexpectedAddUsers,
        });
    }
};

export const deleteGroupById = async (groupId: string): Promise<boolean> => {
    try {
        await deleteGroup(groupId);

        bsAlert({
            title: $Resources.AlertSuccessHeading,
            content: $Resources.AclSuccessDeleteGroup,
        });

        return true;
    } catch (error) {
        bsAlert({
            type: AlertTypes.Danger,
            title: $Resources.ErrorHeading,
            content: $Resources.AclErrorDeleteGroup,
        });

        return false;
    }
};
